import MapboxDirections from "@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions"

export default {
    data() {
        return {
            directionsControl: null
        }
    },
    methods: {
        initDirectionsControl(accessToken) {
            this.directionsControl = new MapboxDirections({
                accessToken: accessToken,
                unit: 'metric',
                interactive: false,
                controls: {
                    inputs: false
                },
                language: this.mapData?.current_locale || 'en'
            });
            this.mySmartMap.addControl(this.directionsControl, 'top-left');
            this.directionsControl.on('route', () => {
                if (document.getElementById('closeInstructionsBtn')) {
                    return;
                }
                let instructions = document.getElementsByClassName('directions-control directions-control-instructions')[0];
                let directionInstructions = document.getElementById('directionInstructions');
                directionInstructions.append(instructions);
            });
        },
        addDirectionsControl() {
            this.mySmartMap.addControl(this.directionsControl, 'top-left');
        },
        removeDirectionsControl() {
            this.mySmartMap.removeControl(this.directionsControl);
        },
    }
}